import { CSSProperties, FC, ReactNode } from 'react';
import { tw } from 'utils/tailwindUtils';

interface TableToolbarProps {
  /** Chips de filtros activos (normalmente un `FilterChipsBar`). */
  chips?: ReactNode;
  /** Acciones de la tabla (buscar, refrescar, columnas, filtros...). */
  actions?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

/**
 * Fila estándar sobre una tabla: chips de filtros a la izquierda y acciones
 * siempre a la derecha. Ambos lados comparten la misma altura mínima (la de
 * un botón de acción, `h-9`) y se alinean arriba, así una sola fila de chips
 * queda centrada con los iconos y, si los chips ocupan varias filas, las
 * acciones se quedan arriba a la derecha sin moverse.
 */
const TableToolbar: FC<TableToolbarProps> = ({
  chips,
  actions,
  className,
  style
}) => (
  <div
    style={style}
    className={tw('flex w-full items-start justify-between gap-3', className)}
  >
    <div className="flex min-h-9 min-w-0 flex-1 items-center">{chips}</div>
    <div className="ml-auto flex min-h-9 shrink-0 items-center gap-1">
      {actions}
    </div>
  </div>
);

export default TableToolbar;
